import { render } from "./facial_biometric.html?vue&type=template&id=2477ad1b&scoped=true&external"
import script from "./facial_biometric.js?vue&type=script&lang=js&external"
export * from "./facial_biometric.js?vue&type=script&lang=js&external"

import "./FacialBiometric.vue?vue&type=style&index=0&id=2477ad1b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2477ad1b"]])

export default __exports__